var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-available"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"fa fa-check-circle-o"})])}
var staticRenderFns = []

export { render, staticRenderFns }